import src from "IMAGE";
export default { src, width: 326667, height: 333333, blurWidth: 0, blurHeight: 0};
